module.exports = __webpack_public_path__ + "static/media/cvo-limited-bronze-armor.20f97b03.png";